import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const FooterInstagram: React.FC<SvgIconProps> = ({
  width = 28,
  height = 29,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => (
  <svg
    viewBox='0 0 28 29'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden={!title}
    focusable='false'
    width={width}
    height={height}
    {...props}
  >
    <path
      d='M0 0.375V28.375H28V0.375H0ZM23.5123 18.3202C23.4664 19.3395 23.3045 20.0352 23.0672 20.6433C22.8233 21.2733 22.4963 21.807 21.9636 22.3386C21.432 22.8713 20.8983 23.1983 20.2683 23.4422C19.6602 23.6795 18.9645 23.8414 17.9452 23.8873C16.9247 23.9344 16.5987 23.9453 14 23.9453C11.4012 23.9453 11.0753 23.9344 10.0538 23.8873C9.03547 23.8414 8.33984 23.6795 7.73063 23.4422C7.10172 23.1983 6.56797 22.8713 6.03641 22.3386C5.50375 21.807 5.17672 21.2733 4.93172 20.6433C4.69547 20.0352 4.53359 19.3395 4.48766 18.3202C4.44062 17.2997 4.42969 16.9737 4.42969 14.375C4.42969 11.7752 4.44062 11.4492 4.48766 10.4288C4.53359 9.41047 4.69547 8.71484 4.93172 8.10563C5.17672 7.47672 5.50375 6.94297 6.03641 6.41031C6.56797 5.87875 7.10172 5.55172 7.73063 5.30672C8.33984 5.07047 9.03547 4.90859 10.0538 4.86266C11.0753 4.81562 11.4012 4.80469 14 4.80469C16.5987 4.80469 16.9247 4.81562 17.9452 4.86266C18.9645 4.90859 19.6602 5.07047 20.2683 5.30672C20.8983 5.55172 21.432 5.87875 21.9636 6.41031C22.4963 6.94297 22.8233 7.47672 23.0672 8.10563C23.3045 8.71484 23.4664 9.41047 23.5123 10.4288C23.5594 11.4492 23.5703 11.7752 23.5703 14.375C23.5703 16.9737 23.5594 17.2997 23.5123 18.3202Z'
      fill={fill}
    />
    <path
      d='M19.1094 10.4146C19.7436 10.4146 20.2578 9.90038 20.2578 9.26611C20.2578 8.63185 19.7436 8.11768 19.1094 8.11768C18.4751 8.11768 17.9609 8.63185 17.9609 9.26611C17.9609 9.90038 18.4751 10.4146 19.1094 10.4146Z'
      fill={fill}
    />
    <path
      d='M14.0002 9.46069C11.2855 9.46069 9.08594 11.6602 9.08594 14.3749C9.08594 17.0885 11.2855 19.2891 14.0002 19.2891C16.7137 19.2891 18.9144 17.0885 18.9144 14.3749C18.9144 11.6602 16.7137 9.46069 14.0002 9.46069ZM14.0002 17.5643C12.2381 17.5643 10.8097 16.1369 10.8097 14.3749C10.8097 12.6129 12.2381 11.1844 14.0002 11.1844C15.7622 11.1844 17.1906 12.6129 17.1906 14.3749C17.1906 16.1369 15.7622 17.5643 14.0002 17.5643Z'
      fill={fill}
    />
  </svg>
)

export default FooterInstagram
